module.exports = __webpack_public_path__ + "media/audio1.d8653ed1.wav";